const ANGLE_THRESHOLD = 45;
const IDLE_SPD_THRESHOLD = 5;
const RIDE_MAX_INTERVAL = 120; // 2 min
const MOTION_SPEED_THRESH = 5;

function getSpeed(lat1, lng1, lat2, lng2, time) {
  const distance = sphericalCosinus(lat1, lng1, lat2, lng2);
  return (time > 0 ?  3.6 * distance / time : 0);
}

function sphericalCosinus(lat1, lon1, lat2, lon2){
  var radius = 6371e3; // meters
  var dLon = toRad(lon2 - lon1);
  lat1 = toRad(lat1);
  lat2 = toRad(lat2);
  var distance = Math.acos(Math.sin(lat1) * Math.sin(lat2) +
    Math.cos(lat1) * Math.cos(lat2) * Math.cos(dLon)) * radius;
  return isNaN(distance) ? 0 : distance;
}

function toRad(n) { return n * Math.PI / 180; }
const WIRELESS_PING_DUR_THRESHOLD = 120;//2 min

function computeTLStats(data) {
  try {
    if (!data || !data.length) return;
    var stats = {
      tps: 0,
      sdt: 0,
      mang: 0,
      dst: 0,
      edt: 0,
      ignOnDur: 0,
      runningTime: 0,
      dur: 0,
      ec: data.length,
      avs: 0
    };
    var runningTimeTs = 0, ignOnTs = 0, durTs = 0;
    var initialLat = 0, initialLon = 0;
    data = data.sort((a, b) => a.ts - b.ts);
    var lastPingIndex = data.length - 1;
    var prevPing;
    if (data[0].ignition) {
      stats.sdt = data[0].ts;
      stats.mang = data[0].ang;
      ignOnTs = data[0].ts;
      if (data[0].lat) {
        initialLat = data[0].lat;
        initialLon = data[0].lng;
        stats.tps = data[0].spd;
      }
    }
    for (var i = 1; i < data.length; i++) {
      var currPing = data[i];
      prevPing = data[i - 1];
      var skip = (currPing.ignition || (currPing.motion && currPing.spd >= MOTION_SPEED_THRESH)) ? false : true;
      if (!currPing.ignition) {
        if (ignOnTs) {
          stats.ignOnDur += prevPing.ts - ignOnTs;
          ignOnTs = 0;
        }
        if (runningTimeTs) {
          stats.runningTime += (prevPing.ts - runningTimeTs);
          runningTimeTs = 0;
        }
      }
      // calculate stats of pings with ignition on and motion on with speed greater than 5 only
      if (skip) {
        if (durTs) {
          stats.dur += (prevPing.ts - durTs);
          durTs = 0;
        }
        continue;
      }
      const dur = currPing.ts - prevPing.ts;
      // Duration - Duration for which ignition was on or motion is true and speed greater than 5
      if (!durTs) durTs = currPing.ts;
      else {
        if (i === (data.length - 1)) { // last ping
          stats.dur += (currPing.ts - durTs);
        } else if (dur > RIDE_MAX_INTERVAL) {
          stats.dur += (prevPing.ts - durTs);
          durTs = currPing.ts;
        }
      }
      if (!currPing.ignition && !currPing.motion) continue;
      // sdt - first ignition on ping
      if (!stats.sdt) stats.sdt = currPing.ts;
      // Top speed
      if (stats.tps < currPing.spd) stats.tps = currPing.spd;
      // Maximum angle
      if (currPing.ang < ANGLE_THRESHOLD && stats.mang < currPing.ang) stats.mang = currPing.ang;
      // edt - last ignition on ping
      stats.edt = currPing.ts;
      // Ignition on duration - Duration for which ignition was on
      if (!ignOnTs) ignOnTs = currPing.ts;
      else if (ignOnTs) {
        if (dur > RIDE_MAX_INTERVAL) {
          stats.ignOnDur += prevPing.ts - ignOnTs;
          ignOnTs = currPing.ts;
        } else if (i === lastPingIndex) {
          stats.ignOnDur += currPing.ts - ignOnTs;
        }
      }

      let runningTime = 0;
      let _spd = currPing.spd || getSpeed(currPing.lat, currPing.lng, prevPing.lat, prevPing.lng, currPing.ts - prevPing.ts);

      // Running time - Duration for which ignition was on and speed was greater than 2
      if (_spd > IDLE_SPD_THRESHOLD) {
        if (runningTimeTs != 0) {
          runningTime = currPing.ts - runningTimeTs;
        }
        runningTimeTs = currPing.ts;
      } else {
        if (runningTimeTs != 0) {
          runningTime = currPing.ts - runningTimeTs;
          runningTimeTs = 0;
        }
      }

      if (i == data.length - 1 && runningTimeTs != 0) {
        runningTime = currPing.ts - runningTimeTs;
        runningTimeTs = 0;
      }

      stats.runningTime += runningTime;

      // Total distance
      if (!initialLat && prevPing.lat) {
        initialLat = prevPing.lat;
        initialLon = prevPing.lng;
      }
      if (currPing.lat && initialLat) {
        stats.dst += sphericalCosinus(initialLat, initialLon, currPing.lat, currPing.lng);
        initialLat = currPing.lat;
        initialLon = currPing.lng;
      }
    }
    stats.avs = stats.dst && stats.dur ? ((stats.dst / stats.dur) * (18 / 5)) : 0; // Converting m/s -> km/hr
    return stats;
  }
  catch (ex) {
    console.log("Error in computeTLStats", ex);
  }
}

function computeWirelessStats(data){
  try{
    if(!data || !data.length) return;
    let sts = Date.now();
    let stats = {
      tps: 0,
      sdt: 0,
      dst: 0,
      edt: 0,
      dur: 0,
      ec: data.length,
      avs: 0,
      runningTime: 0,
    };
    let initialLat = 0, initialLon = 0;
    let sumOfAllSpeedValues = 0, countOfSpeedValues = 0;
    let runningTimeTs = 0, prevPing = {};

    data = data.sort((a, b) => a.ts - b.ts);
    let prevPingTs = 0;
    let currDur = 0;
    data.forEach((ping, index) => {
      if(ping.ts){
        if(!stats.sdt)
          stats.sdt = ping.ts;
        stats.edt = ping.ts
      }

      if(ping.lat && ping.lng){
        if(initialLat && initialLon)
          stats.dst += sphericalCosinus(initialLat, initialLon, ping.lat, ping.lng);

        initialLat = ping.lat;
        initialLon = ping.lng;
      }

      //handle duration
      if(prevPingTs){
        if(ping.ts && (ping.ts - prevPingTs) > WIRELESS_PING_DUR_THRESHOLD || index === (data.length - 1)){
          stats.dur += currDur;
          currDur = 0;
        } else
          currDur += ping.ts - prevPingTs;
      }

      if(ping.spd){
        stats.tps = Math.max(ping.spd, stats.tps);
        sumOfAllSpeedValues += ping.spd;
        countOfSpeedValues++;
      }

      if(ping.ts)
        prevPingTs = ping.ts;

      if(index > 0) prevPing = data[index-1];
      let runningTime = 0;
      let _spd = ping.spd || getSpeed(ping.lat, ping.lng, prevPing.lat, prevPing.lng, ping.ts - prevPing.ts);

      // Running time - Duration for which ignition was on and speed was greater than 5
      if (_spd > IDLE_SPD_THRESHOLD) {
        if (runningTimeTs != 0) {
          runningTime = (ping.ts - runningTimeTs) > 120 ? 1 : (ping.ts - runningTimeTs);
        }
        runningTimeTs = ping.ts;
      } else {
        if (runningTimeTs != 0) {
          runningTimeTs = 0;
        }
      }

      if (index == data.length - 1 && runningTimeTs != 0) {
        runningTime = ping.ts - runningTimeTs;
        runningTimeTs = 0;
      }

      stats.runningTime += runningTime;
    });

    stats.avs = sumOfAllSpeedValues / countOfSpeedValues;// km/h

    console.log("computeTLStats operation finished in " + (Date.now() - sts) + " (ms) for data count(s): " + data.length);
    return stats;
  } catch(e){
    console.error("Error in computeWirelessStats: ", e);
    return;
  }
}

module.exports = {
  computeStats: computeTLStats,
  sphericalCosinus: sphericalCosinus,
  computeWirelessStats: computeWirelessStats,
};